const getUpdatedValue = (changedValue, value) => Object.assign(value !== null ? value : {}, changedValue);

const isMatch = (plot, value) => {
	if (typeof value.min !== 'number' && typeof value.max !== 'number') {
		return true;
	}

	if (typeof value.min === 'number' && typeof value.max === 'number' && value.min > value.max) {
		return false;
	}

	return isPriceBetweenMinAndMax(plot, value) || isPriceRangeBetweenMinAndMaxRangeAndIsPriceNotSet(plot, value);
};

const isPriceBetweenMinAndMax = (plot, value) => (typeof value.min !== 'number' || plot.price !== null && value.min <= plot.price) && (typeof value.max !== 'number' || plot.price !== null && value.max >= plot.price);

const isPriceRangeBetweenMinAndMaxRangeAndIsPriceNotSet = (plot, value) => typeof plot.price !== 'number' &&
	(plot.priceRange === null || typeof plot.priceRange.from !== 'number' || typeof plot.priceRange.to !== 'number') ||
	(
		typeof plot.price !== 'number' &&
		(typeof value.min !== 'number' || value.min <= plot.priceRange.to) &&
		(typeof value.max !== 'number' || value.max >= plot.priceRange.from)
	);

const isSet = (value) => value !== null && (typeof value.min === 'number' || typeof value.max === 'number');

export default {
	getUpdatedValue,
	isMatch,
	isSet,
	isPriceBetweenMinAndMax,
	isPriceRangeBetweenMinAndMaxRangeAndIsPriceNotSet
};